// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"f1f13fb5-168":"e84b0e8cad8f799e74db","f1f13fb5-452":"c88889cccf8316397b32","f1f13fb5-379":"d9b20449f9fa9531d78a","f1f13fb5-83":"6723a5982174a63a1458"}[chunkId] + ".js";
};